import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange }) => {
  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'match', label: 'Match Alerts' },
    { value: 'message', label: 'Messages' },
    { value: 'interview', label: 'Interviews' },
    { value: 'reveal', label: 'Reveal Requests' },
    { value: 'system', label: 'System' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'high', label: 'High Priority' },
    { value: 'normal', label: 'Normal' },
    { value: 'low', label: 'Low' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'unread', label: 'Unread Only' },
    { value: 'read', label: 'Read Only' }
  ];

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} color="#5B2DFF" />
        <h3 className="text-base md:text-lg font-semibold text-[#111827]">Filter Notifications</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search notifications..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          options={typeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
          placeholder="Select type"
        />

        <Select
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
          placeholder="Select priority"
        />

        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Select status"
        />
      </div>
    </div>
  );
};

export default FilterPanel;